import { Component } from '@angular/core';
import { Modal } from '@indice/ng-components';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguageRouterLinkDirective } from '../../../shared/directives/language-router-link.directive';

@Component({
  selector: 'app-sign-prompt-actions-modal',
  standalone: true,
  imports: [TranslocoDirective, LanguageRouterLinkDirective],
  templateUrl: './sign-prompt-actions-modal.component.html',
  styleUrl: './sign-prompt-actions-modal.component.css'
})
export class SignPromptActionsModalComponent {
  constructor(public modalRef: Modal){}

  close = () => this.modalRef.hide();

}
